module.exports = __webpack_public_path__ + "static/media/exercise-example-1.30baef66.png";